import React from 'react'
import PropTypes from 'prop-types'
import Icon from "../Icon";

import classes from './styles.module.css'

function Message({value}) {
    if (!value || !value.type || !value.message) {
        return null; // ничего не показываем, если нет сообщения
    }

    let style = "";
    let icon = null;

    switch (value.type) {
        case "error":
            style = classes.Error;
            icon = <Icon className={classes.Icon} icon="close" size="22px"/>;
            break;

        case "warning":
            style = classes.Warning;
            icon = <Icon className={classes.Icon} icon="warning" size="20px"/>;
            break;

        case "success":
            style = classes.Success;
            icon = <Icon className={classes.Icon} icon="checkmark" size="20px"/>;
            break;

        case "info":
            style = classes.Info;
            icon = <Icon className={classes.Icon} icon="info" size="20px"/>;
            break;

        default:
            break;
    }

    return (
        <div className={style}>
            {icon}
            <span>{value.message}</span>
        </div>
    );
}


Message.propTypes = {
    value: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string
    }),
}

export default Message


// WEBPACK FOOTER //
// ./src/Components/Utils/Message/message.js